import '../styles/globals.css'
import { Provider } from 'react-redux';
import store from "../store/store";
import { useEffect } from 'react';
import Main from '../components/Layout/Main';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Snackbar from '../components/General/Snackbar';
import NextNProgress from 'nextjs-progressbar';
import LCPTracker from '../components/LCPTracker';
import FCPTracker from '../components/FCPTracker';


export default function App({ Component, pageProps }: any) {
	const GOOGLE_CLIENT_ID : any = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID
	const MAINTENANCE_MODE : any = process.env.NEXT_PUBLIC_MAINTENANCE_MODE
 
	useEffect(() => {
		if (process.env.NEXT_PUBLIC_USE_MS_CLARITY === 'true' && process.env.NEXT_PUBLIC_APP_ENVIRONMENT !== 'DEVELOPMENT') {
			(function (c: any, l: any, a: any, r: any, i: any, t: any = null, y: any = null) {
				c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
				t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
				y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
			})(window, document, "clarity", "script", "ebk7oldwc8");
		}
	}, []);

	// FUNCTIONS
	const renderWithLayout =
		Component.SellerLayout ||
		function (page: any) {
			return <Main>{page}</Main>;
		};
	return (
		<>
			<LCPTracker />
			<FCPTracker />
			<Provider store={store}>
				<GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
					<NextNProgress color = "#EC6303" height={3.5} options = {{ showSpinner : false }} />
					{renderWithLayout(<Component {...pageProps} />)}
					<Snackbar />
				</GoogleOAuthProvider>
			</Provider>
		</>
	)
}
